export function SmartProperty(props) {
    switch (props.type) {
        case "link":
            return <a href={props.url}>{props.text}</a>
        case "image":
            //eslint-disable-next-line
            return <img {...props}></img>
    }
    return <div></div>
}